package com.fireavert.info.client.presentation

class InfoPageController(private val interactor: InfoPage) {
    suspend fun queryStringUUID(uuid: String) = interactor.processUUID(uuid)
}